// Sets the tab index for anchor elements within a div
// Used by the alert banner and alert block
export const setTabIndexes = (node: HTMLDivElement, index: string) => {
  const links = node.querySelectorAll("a");
  links.forEach((link) => link.setAttribute("tabindex", index))
}